import { Skeleton } from "@circleco/compass/components/Skeleton";
import { nanoid } from "nanoid";
import { useMemo } from "react";
import Masonry from "react-responsive-masonry";

const DEFAULT_TILE_COUNT = 9;

interface GiphyGridSkeletonProps {
  count?: number;
}

export const GiphyGridSkeleton = ({
  count = DEFAULT_TILE_COUNT,
}: GiphyGridSkeletonProps) => {
  const tiles = useMemo(
    () => Array.from({ length: count }, () => nanoid()),
    [count],
  );

  return (
    <Masonry columnsCount={3} gutter="8px">
      {tiles.map(id => (
        <Skeleton key={id} shape="square" className="size-[120px] rounded-sm" />
      ))}
    </Masonry>
  );
};
